/* imgori theme scripts */
(function () {
  // Mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var links = document.getElementById('NavLinks');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Click-to-play videos (home video slot + video grid)
  function playFrom(el) {
    var tpl = el.querySelector('template');
    if (!tpl || el.classList.contains('playing')) return;
    var img = el.querySelector('img');
    if (img) img.style.display = 'none';
    el.appendChild(tpl.content.cloneNode(true));
    el.classList.add('playing');
    var v = el.querySelector('video');
    if (v) { v.play().catch(function () {}); }
  }
  document.querySelectorAll('[data-video-slot], [data-video-card]').forEach(function (el) {
    el.addEventListener('click', function () { playFrom(el); });
  });


  // Autoplay videos: keep muted + looping, play only while on screen
  var autoVideos = document.querySelectorAll('.video-card.auto video');
  autoVideos.forEach(function (v) {
    v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('muted', ''); v.removeAttribute('controls');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  });
  // Sound toggle on autoplay videos (only one plays with sound at a time)
  document.querySelectorAll('.video-card.auto .vc-sound').forEach(function (btn) {
    btn.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      var turnOn = v.muted;
      autoVideos.forEach(function (o) {
        o.muted = true;
        var b = o.parentElement.querySelector('.vc-sound');
        if (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Unmute video'); }
      });
      if (turnOn) {
        v.muted = false;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Mute video');
      }
    });
  });
  if (autoVideos.length && 'IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else { e.target.pause(); if (!e.target.muted) { e.target.muted = true; var b = e.target.parentElement.querySelector('.vc-sound'); if (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Unmute video'); } } }
      });
    }, { threshold: 0.15 });
    autoVideos.forEach(function (v) { vo.observe(v); });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var items = Array.prototype.slice.call(g.querySelectorAll('.media-item'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.thumb'));
    var counter = g.querySelector('[data-gallery-counter]');
    var current = 0;
    function visible() { return thumbs.filter(function (t) { return t.style.display !== 'none'; }); }
    function pauseAll() {
      g.querySelectorAll('video').forEach(function (v) { v.pause(); });
      g.querySelectorAll('iframe').forEach(function (f) { try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); f.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (e) {} });
    }
    function show(i) {
      var vis = visible();
      if (!vis.length) return;
      current = ((i % vis.length) + vis.length) % vis.length;
      var t = vis[current];
      var idx = thumbs.indexOf(t);
      pauseAll();
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      items.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      if (items[idx]) items[idx].classList.add('active');
      if (counter) counter.textContent = (current + 1) + ' / ' + vis.length;
      var rail = t.parentElement;
      if (rail) rail.scrollTo({ left: t.offsetLeft - rail.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(visible().indexOf(t)); }); });
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    g.querySelectorAll('.thumb-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        g.querySelectorAll('.thumb-tab').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var type = btn.getAttribute('data-filter');
        thumbs.forEach(function (t) { t.style.display = (type === 'all' || t.getAttribute('data-type') === type) ? '' : 'none'; });
        show(0);
      });
    });
    // swipe on touch
    var viewer = g.querySelector('.main-viewer');
    var sx = null;
    if (viewer) {
      viewer.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      viewer.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
  });

  // Bundle tiers
  var form = document.getElementById('ProductForm');
  if (form) {
    var tiers = Array.prototype.slice.call(document.querySelectorAll('.tier'));
    var input = form.querySelector('[data-variant-input]');
    var addBtn = form.querySelector('[data-add-button]');
    var stickyLabel = document.querySelector('[data-sticky-label]');
    var stickyBtn = document.querySelector('.sticky-bar .cta');
    var ctaText = addBtn ? addBtn.textContent.split('—')[0].trim() : 'Add to Cart';
    function select(t) {
      tiers.forEach(function (x) { x.classList.remove('selected'); x.setAttribute('aria-checked', 'false'); });
      t.classList.add('selected');
      t.setAttribute('aria-checked', 'true');
      input.value = t.getAttribute('data-variant-id');
      var qtyInput = form.querySelector('[data-qty-input]');
      if (qtyInput) qtyInput.value = t.getAttribute('data-quantity') || '1';
      var price = t.getAttribute('data-price');
      var available = t.getAttribute('data-available') === 'true';
      if (addBtn) { addBtn.disabled = !available; addBtn.textContent = available ? (ctaText + ' — ' + price) : 'Sold out'; }
      if (stickyBtn) stickyBtn.disabled = !available;
      if (stickyLabel) stickyLabel.textContent = t.getAttribute('data-name') + ' — ' + price;
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
    });
    var initial = document.querySelector('.tier.selected');
    if (initial) select(initial);

    // Sticky add-to-cart bar
    var bar = document.querySelector('[data-sticky-bar]');
    var box = document.querySelector('.buybox');
    if (bar && box && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(box);
    }
  }

  // Cart: auto-update quantity
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (q) {
      q.addEventListener('change', function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        cartForm.appendChild(hidden);
        cartForm.submit();
      });
    });
  }
})();
